var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlackColour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 29,
    viewBox: "0 0 29 29",
    width: 29,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.538 0a2.876 2.876 0 00-2.874 2.88 2.877 2.877 0 002.875 2.879h2.875V2.88A2.88 2.88 0 0010.538 0c.001 0 .001 0 0 0zm0 7.68H2.874A2.877 2.877 0 000 10.56a2.877 2.877 0 002.873 2.88h7.665a2.877 2.877 0 002.875-2.88 2.877 2.877 0 00-2.875-2.88z",
    fill: "#36c5f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.742 10.56a2.877 2.877 0 00-2.874-2.88 2.877 2.877 0 00-2.875 2.88v2.88h2.875a2.878 2.878 0 002.875-2.88zm-7.664 0V2.88A2.878 2.878 0 0018.204 0a2.877 2.877 0 00-2.875 2.88v7.68a2.877 2.877 0 002.874 2.88 2.878 2.878 0 002.875-2.88z",
    fill: "#2eb67d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.203 28.8a2.877 2.877 0 002.875-2.88 2.877 2.877 0 00-2.875-2.879h-2.875v2.88a2.879 2.879 0 002.875 2.88zm0-7.681h7.665a2.877 2.877 0 002.875-2.88 2.877 2.877 0 00-2.874-2.88h-7.665a2.877 2.877 0 00-2.875 2.88 2.876 2.876 0 002.874 2.88z",
    fill: "#ecb22e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.24a2.877 2.877 0 002.875 2.879 2.877 2.877 0 002.874-2.88v-2.88H2.875A2.877 2.877 0 000 18.24zm7.665 0v7.68a2.877 2.877 0 002.873 2.88 2.877 2.877 0 002.875-2.88v-7.678a2.875 2.875 0 10-5.748-.002z",
    fill: "#e01e5a"
  }))));
}

export default SvgSlackColour;